export default {
  drawer: true,
  extended_search: false,
  dropDownData: null,
  directMailDeliveryBoxFlag: false,
  printPublicationTypeBoxFlag: false,
  emailElectronicTypeBoxFlag: false,
  socialNetworkNameBoxFlag: false,
  isCreditOptionOn: false,
  isBankingOptionOn: false,
  isAutomativeOptionOn: false,
  isTravelOptionOn: false,
  isBankingSectorOptionOn: false,
  isEnergyOptionOn: false,
  isHRPayrollOptionOn: false,
  isInsuranceOptionOn: false,
  isInvestmentsOptionOn: false,
  isMortgageOptionOn: false,
  isPharmaceuticalOptionOn: false,
  isEstateOptionOn: false,
  isRetailOptionOn: false,
  isShippingOptionOn: false,
  OldPaginationData: [],
  isTelecomOptionOn: false,
  userSearchDate: null,
  affinityBoxesFlag: false,
  userTime: [],
  toMonth: "",
  toDate: "",
  toYear: "",
  fromYear: "",
  fromMonth: "",
  fromDate: "",
  mediaAPIPayload: [],
  sectorAPIPayload: [],
  audienceAPIPayload: [],
  searchResult: [],
  searchAPIBody: {
    sortby: "entry_id, desc",
    tiebreaker: "product_id, desc",
    mchanne_id: [],
    mpanel_id: [],
    sector_id: [],
  },
  oldPageValue: 0,
  ocrFullTextPayload: {},
  SnackbarFlag: false,
  productNameData: [],
  affinityData: [],
  companyData: [],
  communicationTypeSelection: [],
  DeliveryMethodPayload: [],
  groupSizePayload: [],
  electronicTypePayload: [],
  PublicationTypePayload: [],
  productCompaniesNames: [],
  personalizedRadios: null,
  panelistText: null,
  panelistRadio: null,
  issueTypePayload: null,
  socialPayload: null,
  networkNamePayload: "",
  introductoryPricingPayload: [],
  actionPayload: {},
  searchDate: "",
  betweenTime: "",
  AndTime: "",
  PublicationNamePayload: [],
  searchedBodyData: {},
  searchBtnDisabledFlag: false,
  sectorAll: [],
  mediaAll: [],
  audienceAll: [],
  monthSelectionPayloadState: {},
  raw_additional: [],
  searchBtnFlag: false,
  offerOriginChanged: [],
  searchCriteria: {},
  previousPaginationFlag: false,
  nextPaginationFlag: false,
  lastPaginationFlag: false,
  lastPageNo: null,
  searchResultOption: [],
  lastResultFields: [],
  isSearchAgainFlag: false,
  ocrFullTextSearch: {},
  searchDateSelection: {},
  isAuthLogin: false,
  PublicationNameSelected: [],
  roleUpdatedRawData: {
    media: [],
    sector: [],
    audience: [],
  },
  userRawData: {},
  searchCriteriaGlobal: {},
  myexcelActivation: false,
};
